import { render, staticRenderFns } from "./ProgressSteps.vue?vue&type=template&id=5b5b367e"
import script from "./ProgressSteps.vue?vue&type=script&lang=ts"
export * from "./ProgressSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports